import jwtAuthAxios from "./auth/jwtAuth";

const shippingServices = {};

/**
 * Get pickup / dropoff points for a carrier near an address
 *
 * @param {Object} body
 * @param {String} body.carrier
 * @param {String} body.address
 */
shippingServices.getShippingPoints = async (body) => {
    const { data } = await jwtAuthAxios.post(
        `/shipping/points`,
        body
    );

    return data;
};

export default shippingServices;
